// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* PDF Export Button & Features */

.pdf-export-wrapper {
  position: relative;
  display: inline-block;
}

.pdf-export-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.2s ease-in-out;
}

.pdf-export-btn:not(:disabled):hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.pdf-export-btn:not(:disabled):active {
  transform: translateY(0);
}

.pdf-export-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pdf-export-btn svg {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.pdf-export-error {
  display: flex;
  align-items: center;
  padding: 0.5rem 0.75rem;
  border-radius: 0.375rem;
  font-size: 0.875rem;
}

.pdf-export-error svg {
  flex-shrink: 0;
}

/* Modal Footer with PDF Export */
.modal-footer.d-flex.justify-content-between {
  gap: 1rem;
}

.modal-footer .d-flex.gap-2 {
  gap: 0.5rem;
}

/* Auto-save indicator badge */
.badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0.4rem 0.8rem;
  font-size: 0.8125rem;
  font-weight: 500;
  letter-spacing: 0.5px;
}

.badge .spinner-border {
  width: 12px;
  height: 12px;
  border-width: 2px;
}

/* CBQA Branding in PDF */
.cbqa-header {
  background: linear-gradient(135deg, #1a767e 0%, #15556e 100%);
  color: #ffffff;
  padding: 2rem;
  text-align: center;
  border-radius: 0.5rem;
  margin-bottom: 2rem;
  box-shadow: 0 2px 8px rgba(26, 118, 126, 0.15);
}

.cbqa-header-logo {
  width: 60px;
  height: 60px;
  margin: 0 auto 1rem;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 1.5rem;
}

.cbqa-header-title {
  font-size: 1.75rem;
  font-weight: 700;
  margin: 0 0 0.5rem;
  letter-spacing: 0.5px;
}

.cbqa-header-tagline {
  font-size: 0.875rem;
  font-weight: 500;
  opacity: 0.9;
  margin: 0;
}

/* Document Form Modal enhancements */

/* Height budget lives on .modal-content, not on .modal-body. The body used to
   carry a hardcoded \`max-height: 75vh\` inline, which the header and footer
   then stacked on top of -- so the dialog exceeded the viewport and the footer
   actions fell off the bottom of the screen on phones. Capping the content box
   and letting the body be the only flexible row keeps header and footer pinned
   and always reachable.
   dvh, not vh: on mobile browsers vh measures the *large* viewport (URL bar
   retracted), so a vh cap overflows whenever the URL bar is showing. The vh
   line is the fallback for browsers without dvh. */
.document-form-modal .modal-content {
  max-height: calc(100vh - 3.5rem);
  max-height: calc(100dvh - 3.5rem);
}

.document-form-modal .modal-body {
  flex: 1 1 auto;
  min-height: 0; /* without this a flex item refuses to shrink below content */
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.document-form-modal .modal-header,
.document-form-modal .modal-footer {
  flex-shrink: 0;
}

.document-form-modal .modal-header {
  position: relative;
}

/* Full-bleed on phones: the side margins only cost form width at this size. */
@media (max-width: 575.98px) {
  .document-form-modal {
    margin: 0;
    max-width: 100%;
    min-height: 100dvh;
  }

  .document-form-modal .modal-content {
    min-height: 100dvh;
    max-height: 100dvh;
    border-radius: 0;
  }
}

.document-form-modal .modal-header .ms-auto {
  flex: 0 0 auto;
}

.document-form-modal .modal-title {
  flex: 1 1 auto;
}

/* PDF Export Status Indicators */
.export-status-indicator {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 0.5rem 1rem;
  background: rgba(26, 118, 126, 0.1);
  border-left: 3px solid #1a767e;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  color: #1a767e;
}

.export-status-indicator.success {
  background: rgba(40, 167, 69, 0.1);
  border-left-color: #28a745;
  color: #28a745;
}

.export-status-indicator.error {
  background: rgba(220, 53, 69, 0.1);
  border-left-color: #dc3545;
  color: #dc3545;
}

.export-status-indicator.warning {
  background: rgba(255, 193, 7, 0.1);
  border-left-color: #ffc107;
  color: #856404;
}

/* Print-specific styles */
@media print {
  .pdf-export-btn,
  .modal-footer,
  .btn-close {
    display: none !important;
  }

  .cbqa-header {
    page-break-inside: avoid;
  }

  body {
    background: #ffffff;
  }
}

/* Responsive PDF export */
@media (max-width: 576px) {
  .pdf-export-btn {
    padding: 0.4rem 0.8rem;
    font-size: 0.8rem;
  }

  .modal-footer {
    flex-direction: column;
  }

  .modal-footer button {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/pdfExport.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAEjC;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA,8BAA8B;AAC9B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,6DAA6D;EAC7D,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,SAAS;AACX;;AAEA,qCAAqC;;AAErC;;;;;;;;mDAQmD;AACnD;EACE,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,aAAa,EAAE,6DAA6D;EAC5E,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,8EAA8E;AAC9E;EACE;IACE,SAAS;IACT,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,mCAAmC;EACnC,8BAA8B;EAC9B,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;EAC1B,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE;;;IAGE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,0BAA0B;AAC1B;EACE;IACE,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/* PDF Export Button & Features */\n\n.pdf-export-wrapper {\n  position: relative;\n  display: inline-block;\n}\n\n.pdf-export-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 0.5rem 1rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  transition: all 0.2s ease-in-out;\n}\n\n.pdf-export-btn:not(:disabled):hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.pdf-export-btn:not(:disabled):active {\n  transform: translateY(0);\n}\n\n.pdf-export-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.pdf-export-btn svg {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n}\n\n.pdf-export-error {\n  display: flex;\n  align-items: center;\n  padding: 0.5rem 0.75rem;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n}\n\n.pdf-export-error svg {\n  flex-shrink: 0;\n}\n\n/* Modal Footer with PDF Export */\n.modal-footer.d-flex.justify-content-between {\n  gap: 1rem;\n}\n\n.modal-footer .d-flex.gap-2 {\n  gap: 0.5rem;\n}\n\n/* Auto-save indicator badge */\n.badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 0.4rem 0.8rem;\n  font-size: 0.8125rem;\n  font-weight: 500;\n  letter-spacing: 0.5px;\n}\n\n.badge .spinner-border {\n  width: 12px;\n  height: 12px;\n  border-width: 2px;\n}\n\n/* CBQA Branding in PDF */\n.cbqa-header {\n  background: linear-gradient(135deg, #1a767e 0%, #15556e 100%);\n  color: #ffffff;\n  padding: 2rem;\n  text-align: center;\n  border-radius: 0.5rem;\n  margin-bottom: 2rem;\n  box-shadow: 0 2px 8px rgba(26, 118, 126, 0.15);\n}\n\n.cbqa-header-logo {\n  width: 60px;\n  height: 60px;\n  margin: 0 auto 1rem;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  font-size: 1.5rem;\n}\n\n.cbqa-header-title {\n  font-size: 1.75rem;\n  font-weight: 700;\n  margin: 0 0 0.5rem;\n  letter-spacing: 0.5px;\n}\n\n.cbqa-header-tagline {\n  font-size: 0.875rem;\n  font-weight: 500;\n  opacity: 0.9;\n  margin: 0;\n}\n\n/* Document Form Modal enhancements */\n\n/* Height budget lives on .modal-content, not on .modal-body. The body used to\n   carry a hardcoded `max-height: 75vh` inline, which the header and footer\n   then stacked on top of -- so the dialog exceeded the viewport and the footer\n   actions fell off the bottom of the screen on phones. Capping the content box\n   and letting the body be the only flexible row keeps header and footer pinned\n   and always reachable.\n   dvh, not vh: on mobile browsers vh measures the *large* viewport (URL bar\n   retracted), so a vh cap overflows whenever the URL bar is showing. The vh\n   line is the fallback for browsers without dvh. */\n.document-form-modal .modal-content {\n  max-height: calc(100vh - 3.5rem);\n  max-height: calc(100dvh - 3.5rem);\n}\n\n.document-form-modal .modal-body {\n  flex: 1 1 auto;\n  min-height: 0; /* without this a flex item refuses to shrink below content */\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.document-form-modal .modal-header,\n.document-form-modal .modal-footer {\n  flex-shrink: 0;\n}\n\n.document-form-modal .modal-header {\n  position: relative;\n}\n\n/* Full-bleed on phones: the side margins only cost form width at this size. */\n@media (max-width: 575.98px) {\n  .document-form-modal {\n    margin: 0;\n    max-width: 100%;\n    min-height: 100dvh;\n  }\n\n  .document-form-modal .modal-content {\n    min-height: 100dvh;\n    max-height: 100dvh;\n    border-radius: 0;\n  }\n}\n\n.document-form-modal .modal-header .ms-auto {\n  flex: 0 0 auto;\n}\n\n.document-form-modal .modal-title {\n  flex: 1 1 auto;\n}\n\n/* PDF Export Status Indicators */\n.export-status-indicator {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 0.5rem 1rem;\n  background: rgba(26, 118, 126, 0.1);\n  border-left: 3px solid #1a767e;\n  border-radius: 0.25rem;\n  font-size: 0.875rem;\n  color: #1a767e;\n}\n\n.export-status-indicator.success {\n  background: rgba(40, 167, 69, 0.1);\n  border-left-color: #28a745;\n  color: #28a745;\n}\n\n.export-status-indicator.error {\n  background: rgba(220, 53, 69, 0.1);\n  border-left-color: #dc3545;\n  color: #dc3545;\n}\n\n.export-status-indicator.warning {\n  background: rgba(255, 193, 7, 0.1);\n  border-left-color: #ffc107;\n  color: #856404;\n}\n\n/* Print-specific styles */\n@media print {\n  .pdf-export-btn,\n  .modal-footer,\n  .btn-close {\n    display: none !important;\n  }\n\n  .cbqa-header {\n    page-break-inside: avoid;\n  }\n\n  body {\n    background: #ffffff;\n  }\n}\n\n/* Responsive PDF export */\n@media (max-width: 576px) {\n  .pdf-export-btn {\n    padding: 0.4rem 0.8rem;\n    font-size: 0.8rem;\n  }\n\n  .modal-footer {\n    flex-direction: column;\n  }\n\n  .modal-footer button {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
